module.exports = {
  meta_limits: {
    title: { min: 1, max: 22 },
    description: { min: 0, max: 128 }
  },

  table_limits: {
    utterance: { min: 1, max: 500 },
    intent: { min: 1 },
    context: { min: 1, max: 50 }
  },

  entitiesLimits: {
    roles: { min: 0, max: 10 },
    simple: {
      name: { min: 1, max: 30 }
    },
    regexp: {
      name: { min: 1, max: 30 },
      exp: { min: 1, max: 500 }
    },
    flow: {
      name: { min: 1, max: 30 },
      max_chain_length: 5
    },
    list: {
      name: { min: 1, max: 50 }
    }
  },

  test: {
    phraseMaxLength: 500
  },

  versions: {
    nameMaxLength: 30,
    forbiddenNames: ['unnamed']
  }

}
